<template>
    <div class="videoInfo-wrap">
        <div class="video-item-box">
            <!-- <div class="left" @click="playVideo">
                <el-image 
                    fit="cover"
                    src="https://pic.3gbizhi.com/uploads/20240510/7f0fdb8cf0d1261d9f244fb227481ce5.jpg">
                </el-image>
                <div class="video-time">23分07秒</div>
                <div class="play-icon-box">
                    <i class="el-icon-video-play icon"></i>
                </div>
            </div>
            <div class="right">
                <div class="title">太极松柔养生功 17试《胫骨版》</div>
                <div class="update-time">发布：2020-12-12 20:20</div>
            </div> -->
            <div class="video-title" @click="showIframe">
               {{ itemObj.video_info.video_title }}
            </div>
            <div class="update-time">发布：{{ itemObj.create_time || '--' }}</div>
        </div>
        <el-dialog
            title=""
            append-to-body
            :visible.sync="videoFlag"
            top="30px"
            width="50%"
            v-if="videoFlag"
        >
            <video id="my-player" class="video-js" preload="auto" data-setup='{}' controls autoplay style="height: 70vh;width: 100%; margin: 0 auto; display: block" ref="previewVideo">
                <source src="https://fat-all-o.doutuimao.net/dbzd/video/20240425/DnEwxyWxZAFk4Xzbjsrn1714030578337.mp4"></source>
            </video>
        </el-dialog>
        <el-dialog
            title=""
            :visible.sync="iframeFlag"
            top="30px"
            width="400px"
            v-if="iframeFlag"
        >
            <!-- 根据抖音videoid获取iframe地址 -->
            <!-- https://blog.csdn.net/hzgaoshichao/article/details/138395586 -->
            <div class="iframe-box">
                <iframe @load="iframeLoaded" @error="iframeError" width="100%" height="100%" frameborder="0" :src="getUrl(itemObj.video_info.iframe_code)" referrerpolicy="unsafe-url" allowfullscreen></iframe>
            </div>
        </el-dialog>
    </div>
</template>

<script>
    import videojs from "video.js"
    export default {
        props: {
            itemObj: {
                type: Object,
                default: ()=>{
                    return {
                        "create_time": "", //视频发布时间
                        "item_id": '', //视频ID
                        "dy_video_id": "7281494943544249***", //抖音的视频ID
                        "video_link": "", //视频链接
                        "product_title": "", //课程标题
                        "status": '' ,
                        "video_info": {
                            "iframe_code": "",
                            "video_height": "",
                            "video_title": "",
                            "video_width": ""
                        } //视频信息
                    }
                }
            }
        },
        data(){
            return {
                videoFlag: false,
                iframeFlag: false
            }
        },
        methods: {
            getUrl(originUrl){
                originUrl = decodeURIComponent(originUrl)
                let reg = /(?<=(src="))[^"]*?(?=")/ig;
                let newUrl = originUrl.match(reg);
                return newUrl
            },
            iframeLoaded(e){
                console.log('iframeLoaded-e:',e)
            },
            iframeError(e){
                console.log('iframeError-e:',e)
            },
            showIframe(){
                this.iframeFlag = true
            },
            playVideo(){
                // this.previewObj = item;
                this.videoFlag = true;
                this.$nextTick(() => {
                    this.initVideo()
                })
            },
            initVideo(){
                const player = videojs(this.$refs.previewVideo,{
                    bigPlayButton: true, 
                    posterImage: false,
                    errorDisplay: false,
                    //设置小喇叭音量键
                    controlBar: {
                        fullscreenToggle: true,
                        // 音量条的横向还是纵向显示
                        volumePanel: {
                            inline: false,
                        },
                    },
                    muted: false // //静音模式   解决首次页面加载播放。
                })
                console.log(player, '===player')
            }
        }
    }
</script>

<style scoped lang="less">
.videoInfo-wrap{
    .video-item-box{
        // display: flex;
        .left{
            width: 100px;
            height: 130px;
            position: relative;
            cursor: pointer;
            .video-time{
                position: absolute;
                left: 0;
                bottom: 0;
                background: #000000c4;
                padding: 2px;
                color: #fff;
                font-size: 12px;
                text-align: center;
                width: 100%;
            }
            .play-icon-box{
                opacity: .7;
                position: absolute;
                left: 50%;
                top: 30%;
                transform: translate(-50%, 0);
                background: #000;
                border-radius: 50%;
                height: 30px;
                width: 30px;
                text-align: center;
                .icon{
                    line-height: 30px;
                    color: #fff;
                    font-weight: 800;
                    font-size: 18px;
                }
            }
        }
        .right{
            margin-left: 10px;
            .title{
                font-size: 16px;
            }
            .update-time{
                margin-top: 10px;
                font-size: 12px;
            }
        }
    }
    .video-title{
        font-size: 16px;
        color: #1989FA;
        cursor: pointer;
    }
    .iframe-box{
        height: 75vh;
    }
}
</style>>